import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';
import { SmartButton } from '../../common/SmartButton';

import CustomIcon from '../../common/CustomIcon';

import * as libraryActions from '../../../actions/libraryActions';
import * as bookActions from '../../../actions/bookActions';
import CheckBoxContainer from '../../library/CheckboxContainer';

import * as _ from 'lodash';
import * as messageAlert from '../../../actions/messageAlertAction';
import { Modal, Button, Paragraph } from '@netexknowledge/smart-components';

class CopyBookReveal extends React.Component {
  static propTypes = {
    copyReveal: PropTypes.object,
    libraryActions: PropTypes.object,
    bookActions: PropTypes.object,
    messageAlert: PropTypes.object,
    classrooms: PropTypes.array,
    activeClassroom: PropTypes.object
  };

  constructor(props, context) {
    super(props, context);
    this.classroomCheckBoxes = [];
    this.closeReveal = this.closeReveal.bind(this);
    this.handleCopyBook = this.handleCopyBook.bind(this);
    this.handleBookVinculationCheck = this.handleBookVinculationCheck.bind(this);
    this.handleClassroomCheck = this.handleClassroomCheck.bind(this);

    this.state = {
      selectedClassrooms: [],
      vinculation: false
    };
  }

  componentDidUpdate(prevProps) {
    const { copyReveal } = this.props;
    if (!_.isEqual(copyReveal, prevProps.copyReveal) && !!copyReveal) this.initClassroomCheckBoxes();
  }

  handleClassroomCheck(updatedClassroom) {
    const { selectedClassrooms } = this.state;
    selectedClassrooms.forEach(classroom => {
      if (classroom.id === updatedClassroom.id) classroom.checked = !classroom.checked;
    });
    this.setState({ selectedClassrooms });
  }

  handleCopyBook() {
    const { copyReveal, libraryActions, activeClassroom } = this.props;
    const { vinculation, selectedClassrooms } = this.state;
    const activityId = copyReveal.activityId;
    libraryActions.importBookToCheckedClassrooms(
      activityId,
      selectedClassrooms,
      false,
      !vinculation,
      activeClassroom.sectionId,
      true
    );
    this.closeReveal();
  }

  closeReveal() {
    const { bookActions } = this.props;
    bookActions.setCopyBookReveal();
    this.setState({
      selectedClassrooms: [],
      vinculation: false
    });
  }

  handleBookVinculationCheck() {
    let { vinculation } = this.state;

    vinculation = !vinculation;
    this.setState({ vinculation });
  }

  renderHeader() {
    const title = 'common.copyBookHeader';

    return (
      <div className="header">
        <span className="close-btn" onClick={this.closeReveal}>
          <CustomIcon name="close-button" size={24} />
        </span>
        <span className="title">{I18n.t(title)}</span>
      </div>
    );
  }

  renderVinculationCheckBoxes() {
    const { vinculation } = this.state;
    const title = 'common.bookVinculationReveal';
    return (
      <div className="vinculation-container">
        <Paragraph className="text-grey-700">{I18n.t(title)}</Paragraph>
        <CheckBoxContainer
          checkId={I18n.t('common.vinculationConfirm')}
          checked={vinculation}
          key={'custom-book'}
          onCheck={this.handleBookVinculationCheck}
        />
      </div>
    );
  }

  initClassroomCheckBoxes() {
    const { classrooms, copyReveal, messageAlert } = this.props;
    let selectedClassrooms = [];
    const classroomsWithImportedBook = copyReveal ? copyReveal.classroomsWithImportedBook : [];
    classrooms.forEach(classroom => {
      const classroomFound = _.find(classroomsWithImportedBook, { id: classroom.id });
      if (!classroomFound) {
        classroom.checked = false;
        selectedClassrooms.push(classroom);
      }
    });
    if (_.isEmpty(selectedClassrooms)) {
      messageAlert.warning(I18n.t('common.bookAlreadyExistsAllClassrooms'));
      this.closeReveal();
    }
    this.setState({ selectedClassrooms });
  }

  renderClassroomCheckBoxes() {
    const { selectedClassrooms } = this.state;

    this.classroomCheckBoxes = [];
    selectedClassrooms.forEach((classroom, index) => {
      this.classroomCheckBoxes.push(
        <CheckBoxContainer
          checkId={classroom.name}
          checked={classroom.checked}
          key={index}
          onCheck={this.handleClassroomCheck.bind(this, classroom)}
        />
      );
    });
    return this.classroomCheckBoxes;
  }

  renderFooterButtons() {
    const { selectedClassrooms } = this.state;
    const copyEnabled = !_.isNil(_.find(selectedClassrooms, 'checked'));

    return (
      <div className="import-book-reveal-footer-container">
        <div>
          <SmartButton onClick={this.closeReveal}>{I18n.t('common.cancel')}</SmartButton>
        </div>
        <div>
          <SmartButton success={copyEnabled} disabled={!copyEnabled} onClick={this.handleCopyBook}>
            {I18n.t('common.option.copy')}
          </SmartButton>
        </div>
      </div>
    );
  }

  render() {
    const { copyReveal } = this.props;
    const { selectedClassrooms } = this.state;
    const copyEnabled = !_.isNil(_.find(selectedClassrooms, 'checked'));

    return (
      <Modal
        id="import-book-reveal"
        title={I18n.t('common.copyBook')}
        active={!!copyReveal}
        onClickOutside={this.closeReveal}
        children={
          <div className="classroom-checkbox-container">
            <Paragraph className="text-grey-700">{I18n.t('common.copyBookHeader')}</Paragraph>
            {this.renderClassroomCheckBoxes()}
            {this.renderVinculationCheckBoxes()}
          </div>
        }
        footer={
          <>
            <Button onClick={this.closeReveal} label={I18n.t('common.cancel')}></Button>
            <Button
              onClick={this.handleCopyBook}
              primary
              disabled={!copyEnabled}
              label={I18n.t('common.option.copy')}
            ></Button>
          </>
        }
      ></Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    copyReveal: state.book.copyReveal,
    i18n: state.i18n,
    classrooms: state.classrooms.activeClassrooms,
    activeClassroom: state.classrooms.selectedClassroom.classroom
  };
}

function mapDispatchToProps(dispatch) {
  return {
    libraryActions: bindActionCreators(libraryActions, dispatch),
    bookActions: bindActionCreators(bookActions, dispatch),
    messageAlert: bindActionCreators(messageAlert, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CopyBookReveal);
